import { FormattedNumber } from '../../../../../../components'
import { GetWorkspaceTasksQuotaResult } from '@indigohive/cogfy-types/endpoints/getWorkspaceTasksQuota'
import { RefreshCcw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import clsx, { ClassValue } from 'clsx'

type TasksHistoryCardProps = {
  tasksUsageHistory?: GetWorkspaceTasksQuotaResult[]
  loading?: boolean
  error?: Error | null
  className?: ClassValue
  onRefetch?: () => void
}

export function TasksHistoryCard (props: TasksHistoryCardProps) {
  const {
    tasksUsageHistory = [],
    loading,
    error,
    className,
    onRefetch
  } = props

  const { t } = useTranslation()

  return (
    <>
      {error
        ? (
          <div className='bg-pink-100/75 h-40 flex justify-center items-center gap-2'>
            <span>{t('common:Error fetching data')}</span>
            <button className='btn btn-sm btn-ghost btn-circle' onClick={onRefetch}>
              <RefreshCcw size={16} />
            </button>
          </div>
          )
        : (
          <>
            {loading && (
              <div className="skeleton h-40 border"></div>
            )}
            {!loading && tasksUsageHistory.length === 0 && (
              <div className='flex justify-center items-center h-40 border'>{t('workspaceUsagePage:No data')}</div>
            )}
            {!loading && tasksUsageHistory.length > 0 && (
              <div className={clsx('overflow-x-auto border rounded-lg', className)}>
                <table className='table table-zebra'>
                  <thead className='bg-base-200'>
                    <tr>
                      {tasksUsageHistory[0] &&
                        Object.entries(tasksUsageHistory[0]).map(([key]) => (
                          <th key={key}>
                            {key
                              .replace(/([A-Z])/g, ' $1') // Add a space before uppercase letters
                              .replace(/^./, str => str.toUpperCase())} {/* Capitalize the first letter */}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tasksUsageHistory.filter(history => history !== null).map((history, index) => (
                      <tr key={index}>
                        {Object.entries(history).map(([key, value]) => (
                          <td key={key}>
                            {typeof value === 'number' && (
                              <FormattedNumber value={value} />
                            )
                            }
                            {typeof value === 'string' && (
                              new Date(value).toLocaleDateString('en-US', {
                                month: 'short',
                                day: '2-digit',
                                year: 'numeric'
                              })
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
          )}
    </>
  )
}
